import { SET_CONTENT_CARDS } from '../Types';

// action creators
export const setContentCards = (payload) => ({ type: SET_CONTENT_CARDS, payload });
